import {
	Column,
	Lookup
} from "devextreme-react/data-grid";
import { showErrorMessage } from "../../../../utils/messages";
import { apiGetDocument } from "../api/get-document";
import { useGetDocuments } from "../api/get-documents";
import { useCallback, useState } from "react";
import { CopyToClipboardButton, LoadPagePanel, SyncDataGrid } from "../../../../components";

export default function DocumentGrid() {
	const documents = useGetDocuments();
	const [isDownloading, setIsDownloading] = useState(false);

	const downloadDocument = useCallback(async (e: any, documentID: number) => {

		e.preventDefault();
		setIsDownloading(true);

		apiGetDocument(documentID)
			.then((result) => {
				if (result.isSuccess) {
					window.open(result.signedUrl!);
				}
				else {
					showErrorMessage("Document download error: " + result.errorMessage);
				}
			})
			.finally(() => { setIsDownloading(false); });

	}, []);

	const subjectCellRender = useCallback((cell: any) => {
		return <a href="" target="_blank" onClick={(e) => downloadDocument(e, cell.data.documentID)}>
			{cell.data.documentSubject}
		</a>
	}, []);

	const tinyUrlCellRender = useCallback((cell: any) => {
		if (cell.data.tinyURL)
			return <>{cell.data.tinyURL}&nbsp;<CopyToClipboardButton text={cell.data.tinyURL} title={cell.data.tinyURL} /></>
		else
			return <></>
	}, []);

	return (
		<>
			<SyncDataGrid
				stateStorageKey='documents-grid'
				className={'dx-card wide-card'}
				dataSource={documents.data?.documents}
				height="68vh"
				keyExpr={'documentID'}
				syncLookupFilterValues={false}
				hideExportToExcelButton={true}
				hidePrintButton={true}
				hideChooseColumnsButton={true}
			>
				<Column
					dataField={'documentSubject'}
					caption={'Document Title'}
					dataType="string"
					cellRender={subjectCellRender}
					width={'35%'}
				>
				</Column>
				<Column
					dataField={'synopsis'}
					caption={'Document Description'}
					dataType="string"
					cssClass={'multi-line'}
					width={'35%'}
				/>
				<Column
					dataField={'documentTopic'}
					caption={'Document Topic'}
					dataType="string"
				>
					<Lookup
						dataSource={documents.data?.documentTopics}
						valueExpr={'displayValue'}
						displayExpr={'displayValue'}
					/>
				</Column>
				<Column
					dataField={'tinyURL'}
					caption={'Tiny URL'}
					dataType="string"
					width={'25%'}
					cellRender={tinyUrlCellRender}
				>
				</Column>
				<Column
					dataField={'productLine'}
					caption={'Product Line'}
					dataType="string"
				>
					<Lookup
						dataSource={documents.data?.productLines}
						valueExpr={'description'}
						displayExpr={'description'}
					/>
				</Column>
				<Column
					dataField={'documentFormat'}
					caption={'Document Format'}
					dataType="string"
				>
					<Lookup
						dataSource={documents.data?.documentFormats}
						valueExpr={'displayValue'}
						displayExpr={'displayValue'}
					/>
				</Column>
				<Column
					dataField={'lastUpdatedOn'}
					caption={'Uploaded Date'}
					dataType="date"
					format="shortDate"
					width={100}
				/>
			</SyncDataGrid>
			<LoadPagePanel visible={isDownloading || documents.isLoading} />
		</>
	);
}
